<template>
  <div class="admin-header-actions">
    <notification-drop-down variant="cta" />
    <vs-button
      class="admin-header-refresh"
      icon-pack="feather"
      icon="icon-refresh-ccw"
      :disabled="refreshing"
      @click="refreshAll"
    >
      Refresh
    </vs-button>
  </div>
</template>

<script>
import NotificationDropDown from './NotificationDropDown.vue'

export default {
  name: 'admin-header-actions',
  components: {
    NotificationDropDown
  },
  data() {
    return {
      refreshing: false
    }
  },
  methods: {
    async refreshAll() {
      if (this.refreshing) return
      this.refreshing = true
      try {
        await this.$store.dispatch('adminNotifications/refreshAll')
        this.$root.$emit('admin-header-refresh')
      } finally {
        this.refreshing = false
      }
    }
  }
}
</script>

<style lang="scss">
.admin-header-actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}

.admin-header-refresh {
  margin: 0 !important;
  min-height: 42px !important;
  height: 42px !important;
  padding: 0 16px !important;
}
</style>
